/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LicensingAnimalIdentificationType = "LICENCE" | "MICROCHIP" | "TATTOO" | "%future added value";
export type LicensingMixedBreedSelection = "MIXED" | "PUREBRED" | "%future added value";
export type UpsertLicensingAnimalInput = {
    animalTypeId: string;
    breedId: number;
    breedSelection: LicensingMixedBreedSelection;
    colourId: number;
    dateOfBirth: string;
    foundSbAnimalId?: number | null | undefined;
    genderId: number;
    id?: string | null | undefined;
    identifications?: Array<LicensingAnimalIdentificationInput> | null | undefined;
    isDesexed: boolean;
    licenceTypeId?: number | null | undefined;
    name?: string | null | undefined;
    rabiesVaccinationDateAdministered?: string | null | undefined;
    rabiesVaccinationFileObjectKey?: string | null | undefined;
    rabiesVaccinationImmunityPeriodMonths?: number | null | undefined;
    rabiesVaccinationStorageId?: number | null | undefined;
    secondaryBreedId?: number | null | undefined;
    secondaryColourId?: number | null | undefined;
};
export type LicensingAnimalIdentificationInput = {
    type: LicensingAnimalIdentificationType;
    value: string;
};
export type upsertAnimalMutationVariables = {
    animal: UpsertLicensingAnimalInput;
};
export type upsertAnimalMutationResponse = {
    readonly addOrUpdateLicensingAnimal: {
        readonly id: string | null;
        readonly animal: {
            readonly rabiesVaccination: {
                readonly id: string;
            } | null;
        } | null;
    } | null;
};
export type upsertAnimalMutation = {
    readonly response: upsertAnimalMutationResponse;
    readonly variables: upsertAnimalMutationVariables;
};



/*
mutation upsertAnimalMutation(
  $animal: UpsertLicensingAnimalInput!
) {
  addOrUpdateLicensingAnimal(animal: $animal) {
    id
    animal {
      rabiesVaccination {
        id
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "animal"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "animal",
            "variableName": "animal"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "LicensingRabiesVaccination",
        "kind": "LinkedField",
        "name": "rabiesVaccination",
        "plural": false,
        "selections": [
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "upsertAnimalMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpsertLicensingAnimalResponse",
                    "kind": "LinkedField",
                    "name": "addOrUpdateLicensingAnimal",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingAnimal",
                            "kind": "LinkedField",
                            "name": "animal",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "upsertAnimalMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpsertLicensingAnimalResponse",
                    "kind": "LinkedField",
                    "name": "addOrUpdateLicensingAnimal",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "LicensingAnimal",
                            "kind": "LinkedField",
                            "name": "animal",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "f3b76ca8c11b664a95918ebdfe35ce02",
            "id": null,
            "metadata": {},
            "name": "upsertAnimalMutation",
            "operationKind": "mutation",
            "text": "mutation upsertAnimalMutation(\n  $animal: UpsertLicensingAnimalInput!\n) {\n  addOrUpdateLicensingAnimal(animal: $animal) {\n    id\n    animal {\n      rabiesVaccination {\n        id\n      }\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '633f85b436e73c7807f2abd93c44cfdf';
export default node;
